import React, { lazy } from 'react';
import { useProject } from '../../contexts/ProjectContext';
import { useUI } from '../../contexts/UIContext';
import { AppViewRouterProps } from './types';

const ConceptBuilder = lazy(() => import('../ConceptBuilder'));
const ConceptCanvas = lazy(() => import('../ConceptCanvas'));
const ReportView = lazy(() => import('../ReportView'));

export const ConceptReportViewsRouter: React.FC<AppViewRouterProps> = (props) => {
  const { isProjectEditor } = props;
  const projectCtx = useProject();
  const { projectMetadata, setProjectMetadata } = projectCtx;
  const uiCtx = useUI();
  const { viewMode } = uiCtx;

  const visibleTasks = props.visibleTasks ?? uiCtx.visibleTasks;
  const handleBrainstorm = props.handleBrainstorm ?? uiCtx.handleBrainstorm;
  const conceptBuilderSection = props.conceptBuilderSection !== undefined ? props.conceptBuilderSection : uiCtx.conceptBuilderSection;
  const setConceptBuilderSection = props.setConceptBuilderSection ?? uiCtx.setConceptBuilderSection;
  const handleGenerateConcept = props.handleGenerateConcept ?? projectCtx.handleGenerateConcept;
  const isGeneratingConcept = props.isGeneratingConcept ?? projectCtx.isGeneratingConcept;
  const handleGenerateReport = props.handleGenerateReport ?? projectCtx.handleGenerateReport;
  const isGeneratingReport = props.isGeneratingReport ?? projectCtx.isGeneratingReport;
  const isReportEditing = props.isReportEditing ?? uiCtx.isReportEditing;
  const setIsReportEditing = props.setIsReportEditing ?? uiCtx.setIsReportEditing;
  const editedReport = props.editedReport ?? uiCtx.editedReport;
  const setEditedReport = props.setEditedReport ?? uiCtx.setEditedReport;

  return (
    <>
      {/* Concept Builder */}
      {viewMode === 'conceptBuilder' && (
        <ConceptBuilder 
          metadata={projectMetadata}
          onUpdateMetadata={setProjectMetadata}
          onBrainstorm={handleBrainstorm}
          isReadOnly={!isProjectEditor}
          initialSection={conceptBuilderSection as any}
          onCloseSection={() => setConceptBuilderSection(null)}
        />
      )}

      {/* Concept Canvas */}
      {viewMode === 'concept' && (
        <ConceptCanvas 
          metadata={projectMetadata}
          onBrainstorm={handleBrainstorm}
          onGenerateConcept={() => Promise.resolve(handleGenerateConcept(visibleTasks))}
          isGenerating={isGeneratingConcept}
          isReadOnly={!isProjectEditor}
        />
      )}

      {/* Report View */}
      {viewMode === 'report' && (
        <ReportView 
          metadata={projectMetadata}
          onGenerateReport={handleGenerateReport}
          isGenerating={isGeneratingReport}
          onUpdateMetadata={setProjectMetadata}
          isEditing={isReportEditing}
          setIsEditing={setIsReportEditing}
          editedReport={editedReport}
          setEditedReport={setEditedReport}
          isReadOnly={!isProjectEditor}
        />
      )}
    </>
  );
};

export default ConceptReportViewsRouter;
